import {
  renderMainLeftCell,
  renderColumnGaps,
  renderMainRightCell,
  renderSectionHeaderAsOfDate,
  renderRowGaps
} from '../helpers';

export const renderYieldHeaderRow = headers => {
  let rowString = `<tr>`;
  rowString += renderColumnGaps();
  headers.forEach(header => {
    rowString += renderMainLeftCell(header);
  });
  rowString += `</tr>`;
  return rowString;
};

export const renderYieldRow = data => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell('Fund at NAV');
  rowString += renderMainRightCell(data.distributionRateNAV);
  rowString += renderMainRightCell(data.secYield30DayGross);
  rowString += renderMainRightCell(data.secYield30DayNet);
  rowString += `</tr>`;
  return rowString;
};

export const yieldModule = data => {
  let yieldString = ``;
  yieldString += renderSectionHeaderAsOfDate('Yield', data.date);
  yieldString += renderRowGaps();
  yieldString += renderYieldHeaderRow(data.headers);
  yieldString += renderYieldRow(data);
  yieldString += renderRowGaps(2);
  return yieldString;
};
